import { render, staticRenderFns } from "./BrandIndicator.vue?vue&type=template&id=137d75ac"
import script from "./BrandIndicator.vue?vue&type=script&lang=js"
export * from "./BrandIndicator.vue?vue&type=script&lang=js"
import style0 from "./BrandIndicator.vue?vue&type=style&index=0&id=137d75ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports